import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { Card, CardBody, Container } from 'reactstrap'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService';
import DrugCatlogPage from './DrugCatlogData';
import DrugExclusion from './DrugExclusion';
import Wholsalers from './WholeSalers';
import useAxios from 'hooks/useAxios';

const DrugCatlog = (props) => {
  const { orgId } = props;
  const API = useAxios();

  const {
    states: { drugCatalog, drugExclusion, drugWholeSaler },
    setStates,
    resetStates
  } = useContextService();


  const [collapseSider, setcollapseSider] = useState(false);



  const [tableData, setTableData] = useState([]);
  const [key, setkey] = useState('drugcatlog');
  const [reset, setReset] = useState(false);
  const [reset1, setReset1] = useState(false);
  const [reset2, setReset2] = useState(false);
  const [wholesalersKey, setWholesalersKey] = useState(Date.now());
  const [exclusionKey, setExclusionKey] = useState(Date.now());
  const [catalogKey, setCatalogKey] = useState(Date.now());

  const onKeyChange = (k) => {
    setkey(k);
    // setReset(!reset);
    if (k == 'drugcatlog') {
      setReset(!reset);
      resetStates('drugCatalog')
    }
    if (k == 'drugexclusion') {
      setReset1(!reset1);
      resetStates('drugExclusion')
    }
    if (k == 'wholesalers') {
      setReset2(!reset2);
      resetStates('drugWholeSaler')
    }
  }

  return (
    <div>
      <Container fluid className="width_info bin_info">
        <Card className="border-0 shadow-top">
          <CardBody>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => onKeyChange(k)}
              className="m-0"
            >
              <Tab eventKey="drugcatlog" title="Drug Catalog">
                <DrugCatlogPage orgId={orgId} tabKey={key} reset={reset} />
              </Tab>
              <Tab eventKey="drugexclusion" title="Drug Exclusions">
                <DrugExclusion orgId={orgId} tabKey={key} reset={reset1} />
              </Tab>
              <Tab eventKey="wholesalers" title="Wholesalers">
                <Wholsalers orgId={orgId} tabKey={key} reset={reset2} />
              </Tab>
            </Tabs>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}

export default DrugCatlog
